module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "noMargin",
    staticStyle: {
      "padding-top": "26px !important"
    }
  }, [(_vm.objAuthorize.privileges.indexOf('VENDOR_REPORT') !== -1) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "pageTitle"
  }, [_c('h2', [_vm._v("Purchase Order Report")])]), _vm._v(" "), _c('v-progress-circular', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.soExcelLoading == true),
      expression: "soExcelLoading == true"
    }],
    staticClass: "pt-3 loginLoader",
    staticStyle: {
      "display": "block",
      "float": "left !important",
      "margin-left": "52% !important",
      "margin-top": "12px"
    },
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "reportButtons"
  }, [_c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncShowSalesOrderColumns.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("view_columns")]), _vm._v("MANAGE COLUMNS")]), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncReloadSalesOrder.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons reloadButton"
  }, [_vm._v("refresh")])])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}